import mixpanel from 'shared-components/utils/mixpanel'

export const linkToMaps = location => {
  const url = 'https://maps.google.com/maps?q=' + location.replace(' ', '+')
  mixpanel.trackEvent('Outbound Link Maps', { url })
  window.open(url, '_blank')
}

export const goToWebsite = () => {
  mixpanel.trackEvent('Outbound Link Website', { url: process.env.REACT_APP_WEBSITE })
  window.open(process.env.REACT_APP_WEBSITE, '_blank')
}
